export const feelingDefault = [
  'Neutral',
  'Glad',
  'Koncentrerad',
  'Nedstämd',
  'Pigg',
  'Stressad',
  'Arg',
  'Trött',
  'Sömnig',
];
